<template>
  <div class="c-embed__content">
	<div
		:id="playerId"
		:data-plyr-provider="plyrProvider"
		:data-plyr-embed-id="plyrEmbedId"
	></div>

	<div class="c-embed__message" v-if="!hasCookieConsent">
	  <div class="c-embed__message-content">
		<p>This content is blocked</p>
		<p>Please enable cookies to view</p>

		<button
			class="o-button h-white-space-normal"
			@click="acceptRequiredCategories()"
		>
		  {{ this.requiredCategoryString() }}
		</button>
	  </div>
	</div>
  </div>
</template>

<script>
	import Plyr from "plyr";
	import CookieConsent from "../mixins/cookie-consent.vue";

	export default {
		name: "v-video",
		mixins: [CookieConsent],
		props: {
			plyrProvider: {
				type: String,
			},
			plyrEmbedId: {
				type: String,
			},
			playerId: {
				type: String,
			},
		},
		watch: {
			hasCookieConsent: function () {
				if (!this.hasCookieConsent) {
					return;
				}

				new Plyr(`#${this.$props.playerId}`, {
					captions: {
						active: true,
					},
				});

				let style = document.createElement("link");

				style.href = "https://cdn.plyr.io/3.6.2/plyr.css";
				style.type = "text/css";
				style.rel = "stylesheet";

				document.head.append(style);
			},
		},
	};
</script>
